export class TimerCancelledError extends Error {
  constructor() {
    super('cancelled');
    this.name = 'TimerCancelledError';
  }
}
